export const USER_ROOT_ROUTE: string[] = ['user'];

export const USER_ACCOUNT_ROUTE = [...USER_ROOT_ROUTE, 'account'];
export const PAYMENT_METHOD_ROUTE = [...USER_ROOT_ROUTE, 'payment-method'];
export const NEW_PAYMENT_METHOD_ROUTE = [
  ...USER_ROOT_ROUTE,
  'new-payment-method',
];
export const NEW_LOCATION_ROUTE = [...USER_ROOT_ROUTE, 'new-location'];
export const EDIT_LOCATION_ROUTE = [...USER_ROOT_ROUTE, 'edit-location'];
export const CHANGE_EMAIL_ROUTE = [...USER_ROOT_ROUTE, 'change-email'];
export const CHANGE_PASSWORD_ROUTE = [...USER_ROOT_ROUTE, 'change-password'];
export const USER_DETAIL_ROUTE = [...USER_ROOT_ROUTE, 'detail'];
export const TERMS_CONDITIONS_ROUTE = [...USER_ROOT_ROUTE, 'terms-conditions'];
export const LEGAL_ROUTE = [...USER_ROOT_ROUTE, 'legal'];
export const BUY_CREDITS_ROUTE = [...USER_ROOT_ROUTE, 'buy-credits'];
